(function() {
  require([], function() {
    var $body, $closeCross, $mobileMenu, $readLess, $readMore, $searchWrapper, $toggleLoginMenu, $toggleMenu, $window, acceptTermsCheckBox, gdprEmail, modal, modalClose, validate;
    $body = $("body");
    $window = $(window);
    acceptTermsCheckBox = $("#gdpr-accept-terms-checkbox");
    gdprEmail = $("#gdpr-email");
    validate = function() {
      var acceptTerms;
      acceptTerms = acceptTermsCheckBox.is(":checked");
      if (acceptTerms && gdprEmail.val().indexOf("@" > -1)) {
        return $("#submit-gdpr").prop("disabled", false);
      } else {
        return $("#submit-gdpr").prop("disabled", true);
      }
    };
    gdprEmail.on("input propertychange paste", validate);
    acceptTermsCheckBox.on("change", validate);
    modal = document.getElementById("gdprModal");
    modalClose = $(".gdpr-close");
    modalClose.on("click", function() {
      var warning;
      modal.style.display = "none";
      warning = document.getElementById("gdpr-terms-warning");
      if (warning !== null) {
        return warning.style.display = "block";
      }
    });
    $toggleMenu = $("#toggle-mobile-menu");
    $toggleLoginMenu = $(".secondary-menu-region ul .expanded > a");
    $mobileMenu = $("body");
    if ($toggleMenu.length > 0 && $mobileMenu.length > 0) {
      $toggleMenu.on("click", function() {
        return $mobileMenu.toggleClass("mobile-menu-open");
      });
    }
    $searchWrapper = $("#mobile-search-field");
    $closeCross = $(".close-cross");
    $closeCross.on("click", function() {
      $searchWrapper.addClass("closed");
      return $searchWrapper.removeClass("open");
    });
    $readMore = $("#read-more");
    $readMore.on("click", function() {
      $readMore.addClass("hide");
      return $("#more-field-text").removeClass("hide");
    });
    $readLess = $("#read-less");
    return $readLess.on("click", function() {
      $readMore.removeClass("hide");
      $("#more-field-text").addClass("hide");
      return $([document.documentElement, document.body]).animate({
        scrollTop: $("#ingress-start").offset().top - 200
      }, 200);
    });
  });

}).call(this);

/*
//@ sourceMappingURL=app.js.map
*/;
define("Apps/Account/script/app", function(){});

